import { usePrepareStoredMagazine } from "./prepareStoredMagazine";
import { useBoundStore } from "../zustand/Store";
import { useRouter } from "expo-router";
import { Magazine } from "../Datatypes";
import { useCallback } from "react";

export const useHandleSelectMagazine = () => {
    const router = useRouter();
    const updateCurrentMagazine = useBoundStore((state) => state.updateCurrentMagazine);
    const updateCurrentPage = useBoundStore(useCallback((state) => state.updateCurrentPage, []));
    const prepareStoredMagazine = usePrepareStoredMagazine();
  
    return async (magazine: Magazine) => {
      await prepareStoredMagazine(magazine);
      updateCurrentMagazine(magazine);
      updateCurrentPage(1);
      router.navigate(`../PDFViewer`);
    };
  };
  